import { Badge, Flex, Text } from '@chakra-ui/react'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'

export default function CustomFormSingleSelectionListAnswer() {
  const { answer } = useCustomFormAnswer()

  if (!answer.answer || answer.answer[0] === '') {
    return (
      <Text variant="secondary" fontStyle="italic">
        Sem resposta
      </Text>
    )
  }

  return (
    <Flex gap={2} flexDir="column">
      {answer?.options?.map((option: string, index) => {
        const hasScore = answer?.has_score
        const hasAnswer = answer?.answer?.includes(option)
        const answerScoreSettings = answer?.score_settings?.options[index]
        const scoreOptionKeyValue = hasScore ? answerScoreSettings.value : ''

        const answerIsEqualToOption = answer.answer ? answer.answer[0] === option : false

        if (!hasAnswer) return <></>

        return (
          <Flex align="center" justify="space-between" key={option}>
            <Flex alignItems="center" gap={2}>
              <Text color={'primary'} fontWeight={'medium'}>
                {option}
              </Text>
            </Flex>

            {hasScore && (
              <Badge colorScheme={hasAnswer && answerIsEqualToOption ? 'green' : 'red'}>
                Pontuação: {scoreOptionKeyValue}
              </Badge>
            )}
          </Flex>
        )
      })}
    </Flex>
  )
}
